// src/components/About.jsx
import React from "react";
import "./About.css";

const About = () => {
  return (
    <section id="about" className="about-section">
      <h2>About Me</h2>
      <div className="about-container">
        <div className="about-text">
          <p>
            I am Psychotherapist and Counselor. I practice Gestalt Psychotherapy and Dance Movement Therapy. I am the founder of <a href="https://nirvanapscc.com">Nirvana Psychosocial Care Center & Research Institute</a> and <a href="https://nirvanayogalaya.org">Nirvana Yogalaya</a>. Followed by my Master's in Psychology, I got trained in Gestalt Psychotherapy & Dance Movement Therapy. I am also an Academician and Researcher. I love imparting the knowledge to fellow psychology enthusiasts. I am the faculty of psychology in Tri – Chandra Campus, and Masters in Counselling Psychology (MCP).  As a researcher, my areas of interest are Applied Psychology mostly in Counseling and Psychotherapy and Social Psychology.

          </p>
          <p>
            I have been practicing counseling since 2012 and psychotherapy since 2015. I believe in working with the multidisciplinary team that fosters holistic well-being in an individual. My therapeutic approaches are eclectic, mostly the blend of talk-based therapy, arts and embodied movement-based psychotherapy. I strongly believe the concept of holistic health. That's why I also incorporate the alternative healing modalities Yog, Tibetan Sound healing and Reiki in my private practice. Having more than a decade of experience, I am convinced that, “our body has the wisdom and inherent tendency to heal; we just need to find a way to listen to it.”

          </p>
        </div>
        <img
          src="./About Image.jpg"
          alt="About"
          className="about-img"
        />
      </div>
    </section>
  );
};

export default About;
